import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    DeleteButton
} from 'react-admin';

// own ui
import CustomFilterWayRoute from '../../ui/custom-filter-way-route';
import LinkField from '../../ui/link-field';

const WayRouteFilesList = (props) => (
    <List
      title="Arquivos da Rota" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterWayRoute /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ false } >
        <Datagrid>
          <TextField source="type_file_name" label="Tipo" sortable={true} />
          <LinkField source="url" text="Ver" label="Arquivo" sortable={false}/>
          <TextField source="type" label="Extensão" sortable={true} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <DeleteButton />
        </Datagrid>
    </List>
);

export default WayRouteFilesList;
